import React from "react";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";
import ListTopics from "../components/pages/Content/listTopics";

const ListTopicsLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{margin: "70px 0px 0px 200px", width: "100%"}}>
        <ListTopics />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default ListTopicsLayout;
